<template>
  <div>
    <div class="overlay" @click="close()" />

    <div class="popup">
      <fai
        :icon="['fas', 'times-circle']"
        class="closeMenuButton"
        @click="close()"
      />

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.history.pushState(null, null, location.href);
    window.addEventListener(
      "popstate",
      () => {
        this.close();
      },
      { once: true }
    );
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}

.popup {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white;
  padding: 2rem;
  border-radius: 0.75rem;
}

.closeMenuButton {
  z-index: 9999;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  font-size: 200%;
  color: $colorMMT;
  //  border: 1px solid black;
  // border-radius: 50%;
  // padding: 0.5rem;
  // width: 2rem;
  // height: 2rem;
}
</style>
